import { Form, Select } from "antd";
import { useMemo } from "react";
import { IOption } from "../../../../../../../../../../types/Option";

type YearsItemProps = {
  years: IOption[];
  isLoading: boolean;
};

export const YearsItem = ({ years, isLoading }: YearsItemProps) => {
  const options: IOption[] = useMemo(() => {
    return years.map((item: IOption) => ({
      label: item.value,
      value: item.value,
    }));
  }, [years]);

  return (
    <Form.Item label="Year" name="year" className="years-select mb-6">
      <Select options={options} disabled={isLoading} />
    </Form.Item>
  );
};
